import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_URL } from '../utils/constants';
import { ListResource } from '../utils/lazy-data-source';
import {
  ApiLink,
  ApiListWrapper,
  ApiRequestParams,
  DeepPartial,
} from '../utils/types';
import { AuditRevision } from './audit-revisions.resource';

export interface User {
  _links: {
    self: ApiLink<string>;
    role: ApiLink<number>;
  };
  login: string;
  role_id: number;
  password?: string;
  descr?: string;
  deleted: boolean;
  external?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UsersResource implements ListResource<User> {
  constructor(private httpClient: HttpClient) {
  }

  getList(params?: ApiRequestParams): Observable<ApiListWrapper<User>> {
    return this.httpClient.get<ApiListWrapper<User>>(`${BASE_URL}/users`, { params });
  }

  getItem(login: string): Observable<User> {
    return this.httpClient.get<User>(`${BASE_URL}/users/${login}`);
  }

  create(user: DeepPartial<User>): Observable<void> {
    return this.httpClient.post<void>(`${BASE_URL}/users`, user);
  }

  update(login: string, user: DeepPartial<User>): Observable<void> {
    return this.httpClient.patch<void>(`${BASE_URL}/users/${login}`, user);
  }

  changePassword(login: string, password: string): Observable<void> {
    return this.httpClient.patch<void>(`${BASE_URL}/users/${login}`, { password });
  }

  changeCurrentUserPassword(login: string, oldPassword: string, newPassword: string): Observable<void> {
    return this.httpClient.patch<void>(`${BASE_URL}/users/${login}/pass`, {
      old_password: oldPassword,
      new_password: newPassword,
    });
  }

  getRevisions(login: string, offset?: number, limit?: number): Observable<ApiListWrapper<AuditRevision>> {
    const params: ApiRequestParams = { offset, limit };
    return this.httpClient.get<ApiListWrapper<AuditRevision>>(`${BASE_URL}/users/${login}/revisions`, { params });
  }

  getRevision(login: string, rev: number): Observable<ApiListWrapper<AuditRevision>> {
    return this.httpClient.get<ApiListWrapper<AuditRevision>>(`${BASE_URL}/users/${login}/revisions/${rev}`, { });
  }
}
